<template>
  <div class="rightcontent">
      <div class="midContent">
          <div class="content">
            <div ref="webgl" id="webglPano"></div>
            <div v-if="hasInit&&resData[nowFloor].sandTable_Point.sandTable!=null" ref="webglUp" id="webglPanoUp">
              <img ref="sandImg" :src="resData[nowFloor].sandTable_Point.sandTable.src" alt="" srcset="">
              <div
                v-show="isTopView"
                v-for="(item, i) in resData[nowFloor].sandTable_Point.sandPoints"
                v-bind:key="i"
                :style="`left:${item.posX}px;top:${item.posY}px;transform:rotate(${lon + 90}deg)`"
                class="piontOnWebgl"
                ref="piontOnWebgl"
                >
                <img v-if="sandPointActiveIndex==i" src="images/pointInWebglBg.png">
                <div class="centerCircle" @mousedown="movePoint($event, i)"></div>
                <div v-if="sandPointActiveIndex==i" class="outCircle"></div>
              </div>
            </div>
          </div>
          <BottomBar :nowPanoItemIndex="nowPanoActiveIndex" :resInfos="infos" :resData="resData" :nowFloor="nowFloor"></BottomBar>
      </div>
      <div class="rightBar">
        <div class="rightBarUpWrap">
          <p>
            电子沙盘
            <i class="el-icon-warning-outline"></i>
          </p>
          <div class="btn" @click="addSandTipShow = true">选择图片</div>
        </div>
        <div class="rightBarLine"></div>
        <div class="rightBarMidWrap">
          <div class="addPointBtn" v-if="hasInit&&resData[nowFloor].sandTable_Point.sandTable!=null"  @click="pointTipShow = true">添加标记点</div>
          <div class="pointWrap" v-if="hasInit&&resData[nowFloor].sandTable_Point.sandTable!=null">
            <div class="pointWrapA">
              <el-scrollbar class="page-scroll">
              <div class="pointList">
                <div
                  :class="['point', sandPointActiveIndex===i?'active':'']"
                  v-for="(item, i) in resData[nowFloor].sandTable_Point.sandPoints"
                  v-bind:key="i"
                  @click="changePanoMatFromPoint(i)"
                  >
                  <p class="name"><span class="circleIcon"></span>{{item.panoName}}</p>
                  <P class="xWrap">X:
                    <el-input
                      type="text"
                      v-model="item.posX"
                      size="mini"
                      @blur="changePos"
                      @keyup.enter.native="changePos"
                    >
                    </el-input>
                  </P>
                  <P class="xWrap">Y:
                    <el-input
                      type="text"
                      v-model="item.posY"
                      size="mini"
                      @blur="changePos"
                      @keyup.enter.native="changePos"
                    >
                    </el-input>
                  </P>
                  <i class="el-icon-delete" @click.stop="deletePoint(i)"></i>
                </div>
              </div>
              </el-scrollbar>
            </div>
          </div>
        </div>
        <div class="rightBarLine"></div>
        <div class="rightBarDownWrap">
          <el-checkbox v-model="useSandTable" @change="changeIsSandShow()">是否启用沙盘</el-checkbox>
        </div>
      </div>
      <el-drawer
        :visible.sync="pointTipShow"
        title="选择场景添加到沙盘中"
        @close="panoPointActiveIndex=-1;addPointId=''"
        size="20%">
        <div class="pointTipWrap">
          <div class="rightBarLine"></div>
          <div class="minContent">
            <el-scrollbar style="height:100%;" class="page-scroll">
            <div class="pointTipMidContent">
              <div class="panoPicList">
                <div
                  v-for="(item, i) in getPanoWithoutPointInfos"
                  v-bind:key="i"
                  :class="['panoPicWrap',panoPointActiveIndex===i?'active':'']"
                  @click="panoPointActiveIndex=i;addPointId=item.physicalFile.id">
                  <img :src="item.physicalFile.thumbnailUrl">
                  <p>{{item.physicalFile.fileName}}</p>
                </div>
                <div class="panoPicWrap">
                </div>
                <div class="panoPicWrap">
                </div>
                <div class="panoPicWrap">
                </div>
              </div>
            </div>
            </el-scrollbar>
          </div>
          <div class="rightBarLine"></div>
          <div class="pointTipDownContent">
             <el-button
              type="primary"
              @click="addPoint(addPointId)"
             >完成</el-button>
          </div>
        </div>
      </el-drawer>
      <AddModelTip v-if="addSandTipShow" :type="tipType" :closeFunc="closeTip" :submitFunc="addSourceByType"></AddModelTip>
  </div>
</template>
<style>
  .rightcontent *{
    outline: none;
    color: #fff;
    vertical-align: middle;
  }
  .point .el-input__inner{
    height:20px !important;
    padding:0 5px !important;
    vertical-align: middle;
    position:absolute;
    top:5px;
    color:black;
  }
  .rightBarMidWrap .page-scroll{
    height:100% !important;
  }
  .rightBarMidWrap .el-scrollbar__wrap{
    overflow-x:hidden;
    overflow-y:auto;
  }
  .rightBarMidWrap .el-scrollbar__thumb {
    background-color:#aaa;
    height:10px;
  }

  .rightcontent .el-drawer{
    -webkit-box-shadow: 0 2px 10px 0 rgba(0,0,0,.5) !important;
    box-shadow: 0 2px 10px 0 rgba(0,0,0,.5) !important;
    background-color: #333 !important;
    color: #fff !important;
    outline: none;
    font-size: 20px;
  }

</style>
<style scoped>
.rightcontent{
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-flex: 1;
    -ms-flex: auto;
    flex: auto;
}
.midContent{
    position: relative;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-flow: column nowrap;
    flex-flow: column nowrap;
    background-color: #333;
    color: #fff;
    box-sizing: border-box;
}
.content{
    position: relative;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    border-color: #4b4b4b #000 #000 #4b4b4b;
    border-style: solid;
    border-width: 1px;
    box-sizing: border-box;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-flow: column nowrap;
    flex-flow: column nowrap;
}
.content #webglPanoUp{
  position:absolute;
  max-width:500px;
  max-height:500px;
  top: 19px;
  right: 19px;
  overflow: hidden;
  z-index: 6;
}
.content #webglPanoUp>img{
  max-width:500px;
  max-height:500px;
}
.content #webglPanoUp.active{
  z-index: 6;
}
.content .viewBtn{
  position:absolute;
  right:5px;
  top:5px;
  font-size:20px;
  cursor: pointer;
}
.content .viewBtn .isTopView{
  color:#0057ff;
}
.content #webglPanoUp .piontOnWebgl{
  width:50px;
  height:50px;
  position:absolute;
  left:0;
  top:0;
  z-index: 99;
}
.content #webglPanoUp .piontOnWebgl img{
  width: 100%;
  height: 100%;
}
.content #webglPanoUp .piontOnWebgl .centerCircle{
  width:14px;
  height:14px;
  background-color: #0057ff;
  border-radius: 50% 50%;
  position:absolute;
  left: 50%;
  top:50%;
  transform: translateX(-50%) translateY(-50%);
  cursor: pointer;
}
.content #webglPanoUp .piontOnWebgl .outCircle{
  width:10px;
  height:10px;
  background-color: #f00;
  border-radius: 50% 50%;
  position:absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 1px;
  cursor: ew-resize;
}
.content #webglPano{
  position:absolute;
  top: 20px;
  left: 20px;
  bottom: 20px;
  right: 20px;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, .7);
  overflow: hidden;
  border-radius: 2px 2px;
  z-index: 5;
}
.rightBar{
  -ms-flex: 0 0 230px;
  flex: 0 0 230px;
  width: 230px;
  position: relative;
  -webkit-box-flex: 0;
  border-color: #4b4b4b #000 #000 #4b4b4b;
  border-style: solid;
  border-width: 1px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-flow: column nowrap;
  flex-flow: column nowrap;
  background-color: #333;
  color: #fff;
}
.rightBarUpWrap {
  position: relative;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 60px;
  flex:  0 0 60px;
  padding: 10px 15px;
}
.rightBarUpWrap p{
  height:40px;
  width: 100px;
  position: absolute;
  line-height: 40px;
  left: 15px;
  font-size: 14px;
  text-align: left;
}
.rightBarUpWrap .btn{
  height:30px;
  width: 100px;
  position: absolute;
  line-height: 30px;
  right: 15px;
  top: 15px;
  font-size: 14px;
  background-color: #0057ff;
  color:#fff;
  cursor: pointer;
  border-radius: 4px 4px;
}
.rightBarMidWrap {
  position: relative;
  -webkit-box-flex:1;
  -ms-flex: 1 auto;
  flex:  1 auto;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-flow: column nowrap;
  flex-flow: column nowrap;
  overflow: hidden;
}
.rightBarMidWrap .addPointBtn{
  position: relative;
  -webkit-box-flex:0;
  -ms-flex: 0 0 34px;
  flex:  0 0 34px;
  background-color: #286efa;
  color: #fff;
  line-height: 34px;
  border-radius: 2px 2px;
  margin-top:20px;
  margin-bottom: 20px;
  cursor: pointer;
  width:150px;
  margin-left: 40px;
}
.rightBarMidWrap .pointWrap{
  position: relative;
  -webkit-box-flex:1;
  -ms-flex: 1 auto;
  flex:  1 auto;
  overflow: hidden;
}
.rightBarMidWrap .pointWrapA{
  position: relative;
  width: 100%;
  height: calc(100vh - 240px);
  /* max-height: calc(100vh - 240px); */
  /* max-height: 700px; */
  overflow: hidden;
}
.rightBarMidWrap .pointList{
  position: relative;
  width:100%;
  overflow: hidden;
}
.rightBarMidWrap .point{
   position: relative;
   width:100%;
   height: 120px;
   background-color: #3a3a3a;
   margin-bottom: 10px;
   cursor: pointer;
}
.rightBarMidWrap .point .name{
  position: relative;
  height:30px;
  left:10px;
  line-height: 30px;
  text-align: left;
  text-indent: 20px;
  font-size: 16px;
}
.rightBarMidWrap .point .name .circleIcon{
  display: block;
  width:12px;
  height: 12px;
  position: absolute;
  background-color: #999;
  border-radius: 6px 6px;
  top: 9px;
}
.rightBarMidWrap .point.active .circleIcon{
  background-color: #fbd14b;
}
.rightBarMidWrap .point i{
  position: absolute;
   height:30px;
   right:30px;
   line-height: 30px;
   top:0;
  font-size: 16px;
  cursor: pointer;
}
.rightBarMidWrap .point .xWrap{
  height:30px;
  position: relative;
  vertical-align: middle;
  line-height: 30px;
  text-align: left;
  font-size: 16px;
  text-indent: 10px;
}
.rightBarMidWrap .point .xWrap .el-input{
  position: absolute;
  width:180px;
  font-size: 16px;
  left: 30px;
}
.rightBarLine{
  width: 100%;
  height: 2px;
  border-top: 1px solid rgb(0, 0, 0);
  border-bottom: 1px solid rgb(75, 75, 75);
}
.rightBarDownWrap{
  -webkit-box-flex: 0;
  -ms-flex: 0 0 60px;
  flex: 0 0 60px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 0 15px;
}
.pointTipWrap{
  position: relative;
  width:100%;
  height:100%;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-flow: column nowrap;
  flex-flow: column nowrap;
  color: #fff;
}
.pointTipWrap .minContent{
  position: relative;
  width: 100%;
  height: 85%;
}
.pointTipWrap .pointTipMidContent{

  -webkit-box-flex: 1;
  -ms-flex: 1 auto;
  flex: 1 auto;
  display: -webkit-box;
  display: -ms-flexbox;
  padding: 20px 15px;
}
.pointTipWrap .panoPicList{
  display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-flow: row wrap;
    flex-flow: row wrap;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
}
/* .pointTipWrap .panoPicList:after {
    content: "";
    flex: auto;
 } */

.pointTipWrap .pointTipMidContent .panoPicWrap{
  width: 100px;
  margin-bottom: 20px;
  cursor: pointer;
}
.pointTipWrap .pointTipMidContent .panoPicWrap.active img{
  outline: 2px solid #ffbd10;
  outline-offset: -2px;
}
.pointTipWrap .panoPicWrap img{
  width: 100px;
  height: 100px;
}
.pointTipWrap .panoPicWrap p{
  width: 100px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  font-size: 16px;
}

.pointTipWrap .pointTipDownContent{
  -webkit-box-flex: 0;
  -ms-flex: 0 0 60px;
  flex: 0 0 60px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 0 100px;
  text-align: center;
}
.pointTipWrap .pointTipDownContent button{
  -webkit-box-flex: 1;
  -ms-flex: 1 auto;
  flex: 1 auto;
}

</style>
<script>
import BottomBar from '../components/webgl/BottomBar.vue'
import AddModelTip from '../components/database.vue'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader_z'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader'
import { FBXLoader } from 'three/examples/jsm/loaders/FBXLoader.js'
import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader.js'
import { MTLLoader } from 'three/examples/jsm/loaders/MTLLoader.js'
import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader.js'
import { TWEEN } from 'three/examples/jsm/libs/tween.module.min'
import https from '../https.js'
let vm = null
const vertexShader = [
  'varying vec3 pPos;',
  'void main()',
  '{',
  '    pPos = position;',
  '    vec4 mvPosition = modelViewMatrix * vec4( position, 1.0 );',
  '    gl_Position = projectionMatrix * mvPosition;',
  '}'
].join('\n')

const fragmentShader = [
  '#ifdef GL_ES',
  '    precision highp float;',
  '#endif',
  'const float PI = 3.1415926;',
  'const float TWO_PI = 6.2831852;',

  'uniform samplerCube texture;',
  'uniform vec3 cPosition;',
  'varying vec3 pPos;',
  'void main()',
  '{',
  '    vec3 np = normalize(pPos-cPosition);',
  '    gl_FragColor = textureCube( texture, vec3(np.x,np.y,-np.z ));',
  '}'
].join('\n')
export default {
  name: '',
  components: {
    BottomBar,
    AddModelTip
  },
  computed: {
    nowPointActiveIndex: function() {
      return this.panoEditInfos.nowPointActiveIndex
    },
    sandPointActiveIndex: function() {
      return this.panoEditInfos.sandPointActiveIndex
    },
    nowPanoActiveIndex: function() {
      return this.panoEditInfos.nowPanoActiveIndex
    },
    getPanoInfos: function() {
      var arr = []
      return this.infos.panos ? this.infos.panos : arr
    },
    getModel: function() {
      return this.infos.model ? this.infos.model : {}
    },
    getSand: function() {
      return this.infos.sandTable_Point
    },
    getPointInfos: function() {
      var arr = []
      if(this.infos.panos) {
        for(var i = 0; i < this.infos.panos.length; i++) {
          if(this.infos.panos[i].posX != null) {
            arr.push(this.infos.panos[i])
          }
        }
      }
      return arr
    },
    getPanoWithoutPointInfos: function() {
      var arr = []
      if(this.resData[this.nowFloor]) {
        for(var i = 0; i < this.resData[this.nowFloor].panos.length; i++) {
          if(!this.findPanoInPoint(this.resData[this.nowFloor].panos[i].physicalFile.id)) {
            arr.push(this.resData[this.nowFloor].panos[i])
          }
        }
      }
      return arr
    }
  },
  props: [
    'infos',
    'panoEditInfos',
    'nowFloor',
    'resData'
  ],
  data() {
    return {
      lon: 270,
      lat: 0,
      phi: 0,
      theta: 0,
      x: 0,
      y: 0,
      z: 0,
      useModel: false,
      pointTipShow: false,
      addPanoBtnCanUse: false,
      panoPointActiveIndex: -1,
      // nowPointActiveIndex: 0,
      // nowPanoActiveIndex: 0,
      pointInfos: [],
      addPointId: '',
      isTopView: true,
      addSandTipShow: false,
      tipType: '4',
      hasModel: false,
      hasSand: false,
      hasInit: false,
      useSandTable: false,
      sandPic: '',
      sandInfo: {
        points: [
        ]
      }
    }
  },
  created() {
    document.oncontextmenu = function() {
      return false
    }
    vm = this
    if(this.resData && this.resData.length > 0) {
      this.hasInit = true
      this.useSandTable = this.resData[this.nowFloor].isSandShow
      var id = this.resData[this.nowFloor].panos[this.nowPanoActiveIndex].physicalFile.id
      if(this.resData[this.nowFloor].sandTable_Point.sandPoints != null) {
        var pointNum = this.resData[this.nowFloor].sandTable_Point.sandPoints.findIndex(item => item.panoID === id)
        this.$parent.changePanoEditInfos('sandPointActiveIndex', pointNum)
      }
    }
  },
  watch: {
    getPanoInfos(val) {
      if(!this.hasInit) {
        this.hasInit = true
        this.useSandTable = this.resData[this.nowFloor].isSandShow
        this.generatePano(this.panoGroup, this.resData[this.nowFloor].panos[this.nowPanoActiveIndex])
        var id = this.resData[this.nowFloor].panos[this.nowPanoActiveIndex].physicalFile.id
        if(this.resData[this.nowFloor].sandTable_Point.sandPoints != null) {
          var pointNum = this.resData[this.nowFloor].sandTable_Point.sandPoints.findIndex(item => item.panoID === id)
          this.$parent.changePanoEditInfos('sandPointActiveIndex', pointNum)
        }
      }
    }
  },
  mounted () {
    this.containerUp = null
    this.sceneUp = null
    this.cameraUp = null
    this.meshUp = null
    this.rendererUp = null
    this.containerWUp = 0
    this.containerHUP = 0
    this.targetBoxUp = null
    this.rafId = null
    this.container = null
    this.scene = null
    this.camera = null
    this.mesh = null
    this.renderer = null
    this.controls = null
    this.containerW = 0
    this.containerH = 0
    this.selectionBox = null
    this.transformControls = null
    this.mouse = new THREE.Vector2()
    this.raycaster = new THREE.Raycaster()
    this.onDownPosition = new THREE.Vector2()
    this.onUpPosition = new THREE.Vector2()
    this.pmremGenerator = null
    this.isDown = false
    this.isMoving = false
    this.isModelShow = false
    this.panoGroup = new THREE.Group()
    this.fingers = null
    this.onPointerDownPointerX = 0
    this.onPointerDownPointerY = 0
    this.onPointerDownLon = 0
    this.onPointerDownLat = 0
    this.onPointerDownPointerX0 = 0
    this.onPointerDownPointerY0 = 0
    this.onPointerDownPointerX1 = 0
    this.onPointerDownPointerY1 = 0
    this.preMoveX = 0
    this.preMoveY = 0
    this.offX = 0
    this.offY = 0
    this.disFinger = 0
    this.canDamp = false
    this.dampingFactor = 0.2
    this.targetBox = null
    this.hasLoaded = false
    this.planeUniforms = null
    this.preV = new THREE.Vector2()
    this.textrueLoader = new THREE.TextureLoader()
    this.clock = new THREE.Clock()
    // this.getZoom('piontOnWebgl', 'webglUp')
    this.init()
    this.animate()
  },
  methods: {
    changeIsSandShow() {
      this.resData[this.nowFloor].isSandShow = this.useSandTable
    },
    findPanoInPoint(id) {
      for (let i = 0; i < this.resData[this.nowFloor].sandTable_Point.sandPoints.length; i++) {
        if(id == this.resData[this.nowFloor].sandTable_Point.sandPoints[i].panoID) {
          return true
        }
      }
      return false
    },
    deletePoint(num) {
      this.resData[this.nowFloor].sandTable_Point.sandPoints.splice(num, 1)
      if(this.resData[this.nowFloor].sandTable_Point.sandPoints.length > num) {
        this.$parent.changePanoEditInfos('sandPointActiveIndex', num)
      }else{
        this.$parent.changePanoEditInfos('sandPointActiveIndex', num - 1)
      }
      this.changePanoMatFromPoint(this.sandPointActiveIndex)
    },
    closeTip() {
      this.addSandTipShow = false
    },
    addSourceByType(data) {
      if(this.resData[this.nowFloor].sandTable_Point.sandTable == null) {
        this.resData[this.nowFloor].sandTable_Point.sandTable = {}
      }
      this.resData[this.nowFloor].sandTable_Point.sandTable.src = data[0].filePath
      this.hasSand = true
    },
    changeView() {
      if(this.nowPointActiveIndex !== -1) {
        if(this.isTopView) {
          this.isTopView = false
          var pos = this.getPointInfos[this.nowPointActiveIndex].position
          this.cameraUp.position.set(pos.x, pos.y, pos.z)
          this.posObj(this.targetBoxUp, this.cameraUp, 10000, this.lon, this.lat, 0)
        }else{
          this.isTopView = true
          this.cameraUp.position.set(0, 45000, 0)
          this.targetBoxUp.position.set(0, 0, 0)
        }
      }
    },
    addPoint(id) {
      if(id !== '') {
        if(this.resData[this.nowFloor].sandTable_Point.sandPoints == null) {
          this.resData[this.nowFloor].sandTable_Point.sandPoints = []
        }
        this.resData[this.nowFloor].sandTable_Point.sandTable.width = this.$refs.sandImg.clientWidth
        this.resData[this.nowFloor].sandTable_Point.sandTable.height = this.$refs.sandImg.clientHeight
        console.log(this.resData[this.nowFloor].sandTable_Point.sandTable)
        for(var i = 0; i < this.resData[this.nowFloor].panos.length; i++) {
          if(this.resData[this.nowFloor].panos[i].physicalFile.id === id) {
            var point = {}
            point.posX = this.resData[this.nowFloor].sandTable_Point.sandTable.width / 2 - 25
            point.posY = this.resData[this.nowFloor].sandTable_Point.sandTable.height / 2 - 25
            point.panoID = id
            // point.id = '00000000-0000-0000-0000-000000000000'
            point.panoName = this.resData[this.nowFloor].panos[i].physicalFile.fileName
            point.typeIndex = 1
            point.sandTableID = this.resData[this.nowFloor].sandTable_Point.sandTable.id
            this.resData[this.nowFloor].sandTable_Point.sandPoints.push(point)
            this.$parent.changePanoEditInfos('nowPanoActiveIndex', i)
          }
        }
        this.pointTipShow = false
        this.$parent.changePanoEditInfos('sandPointActiveIndex', this.resData[this.nowFloor].sandTable_Point.sandPoints.length - 1)
        this.changePanoMat(this.nowPanoActiveIndex)
      }else{
        this.$notify({
          title: '警告',
          message: '请选择需要添加点的全景图',
          duration: 1000,
          type: 'warning'
        })
      }
    },
    changePos() {
      var pos = new THREE.Vector3(
        this.getPointInfos[this.nowPointActiveIndex].position.x,
        this.getPointInfos[this.nowPointActiveIndex].position.y,
        this.getPointInfos[this.nowPointActiveIndex].position.z
      )
      var vec = pos.project(this.cameraUp)
      // this.getPointInfos[this.nowPointActiveIndex].screenPos.x = Math.round(vec.x * 320 + 320) - 25
      // this.getPointInfos[this.nowPointActiveIndex].screenPos.y = Math.round(-vec.y * 180 + 180) - 25

      this.infos.panos[this.nowPanoActiveIndex].screenPos = {}
      this.infos.panos[this.nowPanoActiveIndex].screenPos.x = Math.round(vec.x * 320 + 320) - 25
      this.infos.panos[this.nowPanoActiveIndex].screenPos.y = Math.round(-vec.y * 180 + 180) - 25

      if(!this.isTopView) {
        var posC = this.getPointInfos[this.nowPointActiveIndex].position
        this.cameraUp.position.set(posC.x, posC.y, posC.z)
        this.posObj(this.targetBoxUp, this.cameraUp, 10000, this.lon, this.lat, 0)
      }
    },
    movePoint(ev, num) {
      var oEvent = ev || event
      oEvent.preventDefault()
      var prePosX = oEvent.clientX
      var prePosY = oEvent.clientY
      var preLeft = vm.resData[this.nowFloor].sandTable_Point.sandPoints[num].posX
      var preTop = vm.resData[this.nowFloor].sandTable_Point.sandPoints[num].posY
      var nowLeft, nowTop, offsetX, offsetY
      this.changePanoMatFromPoint(num)
      document.onmousemove = function(ev) {
        var oEvent = ev || event
        offsetX = oEvent.clientX - prePosX
        offsetY = oEvent.clientY - prePosY
        if(Math.abs(offsetX) > 1 || Math.abs(offsetY) > 1) {
          nowLeft = preLeft + offsetX
          nowTop = preTop + offsetY
          if(nowLeft >= -25 && nowLeft <= vm.resData[vm.nowFloor].sandTable_Point.sandTable.width - 25) {
            vm.resData[vm.nowFloor].sandTable_Point.sandPoints[num].posX = nowLeft
          }
          if(nowTop >= -25 && nowTop <= vm.resData[vm.nowFloor].sandTable_Point.sandTable.height - 25) {
            vm.resData[vm.nowFloor].sandTable_Point.sandPoints[num].posY = nowTop
          }
        }
      }
      document.onmouseup = function() {
        document.onmousemove = null
        document.onmouseup = null
      }
    },
    getZoom(d1, d2) {
      var _this = this
      var oDiv1 = this.$refs[d1]
      var oDiv2 = this.$refs[d2]

      var containerW = oDiv2.clientWidth
      var containerH = oDiv2.clientHeight
      oDiv1.onmousedown = (ev) => {
        ev.preventDefault()
        var oEvent = ev || event
        console.log(oEvent)
        var prePosX = oEvent.clientX
        var prePosY = oEvent.clientY
        var preLeft = oDiv1.offsetLeft
        var preTop = oDiv1.offsetTop

        document.onmousemove = function(ev) {
          var oEvent = ev || event
          var offsetX = oEvent.clientX - prePosX
          var offsetY = oEvent.clientY - prePosY
          var nowLeft = preLeft + offsetX
          var nowTop = preTop + offsetY
          // if(nowLeft >= -25 && nowLeft <= containerW - 25) {
          //   vm.getPointInfos[num].screenPos.x = nowLeft
          // }
          // if(nowTop >= -25 && nowTop <= containerH - 25) {
          //   vm.getPointInfos[num].screenPos.y = nowTop
          // }
        }
        document.onmouseup = function() {
          document.onmousemove = null
          document.onmouseup = null
        }
      }
    },
    init () {
      this.container = this.$refs.webgl
      this.containerW = this.$refs.webgl.getBoundingClientRect().width
      this.containerH = this.$refs.webgl.getBoundingClientRect().height
      this.scene = new THREE.Scene()
      this.targetBox = new THREE.Mesh(
        new THREE.BoxBufferGeometry(1, 1, 1),
        new THREE.MeshBasicMaterial({
          color: 0xff0000,
          transparent: true,
          opacity: 0
        })
      )
      this.scene.add(this.targetBox)
      this.scene.add(this.panoGroup)
      this.camera = new THREE.PerspectiveCamera(
        60,
        this.containerW / this.containerH,
        10,
        99999
      )

      this.camera.position.set(0, 0, 0)
      this.posObj(this.targetBox, this.camera, 10000, this.lon, this.lat, 0)
      this.camera.lookAt(this.targetBox.position)
      this.scene.add(this.camera)

      const ambientLight = new THREE.AmbientLight(0xffffff)
      this.scene.add(ambientLight)
      this.planeUniforms = {
        cPosition: { value: new THREE.Vector3() },
        texture: { value: null },
        ...THREE.UniformsLib.lights
      }
      const planeMat = new THREE.ShaderMaterial({
        uniforms: this.planeUniforms,
        vertexShader: vertexShader,
        fragmentShader: fragmentShader,
        lights: true
      })
      planeMat.needsUpdate = true
      if(this.resData.length > 0 && this.resData[this.nowFloor].panos) {
        this.generatePano(this.panoGroup, this.resData[this.nowFloor].panos[this.nowPanoActiveIndex])
      }
      this.renderer = new THREE.WebGLRenderer({
        antialias: true,
        alpha: true
      })
      this.renderer.setPixelRatio(window.devicePixelRatio)
      this.renderer.setSize(this.containerW, this.containerH)
      this.container.appendChild(this.renderer.domElement)
      window.addEventListener('resize', this.onresize, false)

      this.renderer.domElement.addEventListener('mousedown', this.onRendererMouseDown, false)
      this.renderer.domElement.addEventListener('mousemove', this.onRendererMouseMove, false)
      this.renderer.domElement.addEventListener('mouseup', this.onRendererMouseUp, false)
    },
    onRendererMouseDown(event) {
      event.preventDefault()
      this.isMoving = false
      this.isDown = true
      this.canDamp = false
      this.preV.x = event.clientX
      this.preV.y = event.clientY
      this.preMoveX = this.onPointerDownPointerX = event.clientX
      this.preMoveY = this.onPointerDownPointerY = event.clientY
      this.onPointerDownLon = this.lon
      this.onPointerDownLat = this.lat
    },
    onRendererMouseMove(event) {
      event.preventDefault()
      this.isMoving = true
      if(this.isDown) {
        this.lon = (this.onPointerDownPointerX - event.clientX) * 0.15 + this.onPointerDownLon
        this.lat = (event.clientY - this.onPointerDownPointerY) * 0.15 + this.onPointerDownLat
        this.posObj(this.targetBox, this.camera, 1, this.lon, this.lat, 0)
        if(!this.isTopView && this.nowPointActiveIndex !== -1) {
          this.posObj(this.targetBoxUp, this.cameraUp, 1, this.lon, this.lat, 0)
        }
        this.offX = event.clientX - this.preMoveX
        this.offY = event.clientY - this.preMoveY
        this.preMoveX = event.clientX
        this.preMoveY = event.clientY
      }
    },
    onRendererMouseUp() {
      this.isMoving = false
      this.isDown = false
    },
    changePanoMatFromPoint(num) {
      // this.nowPointActiveIndex = num
      this.$parent.changePanoEditInfos('sandPointActiveIndex', num)
      var id = this.resData[this.nowFloor].sandTable_Point.sandPoints[num].panoID
      var panoNum = this.resData[this.nowFloor].panos.findIndex(item => item.physicalFile.id === id)
      console.log(id)
      console.log(num, panoNum)
      this.$parent.changePanoEditInfos('nowPanoActiveIndex', panoNum)
      // this.nowPanoActiveIndex = panoNum
      this.lon = 270
      this.lat = 0
      this.posObj(this.targetBox, this.camera, 10000, this.lon, this.lat, 0)
      var r = this.resData[this.nowFloor].panos[this.nowPanoActiveIndex].physicalFile.filePath
      var urls = [
        r + '/l1_r_1_1.jpg',
        r + '/l1_l_1_1.jpg',
        r + '/l1_u_1_1.jpg',
        r + '/l1_d_1_1.jpg',
        r + '/l1_f_1_1.jpg',
        r + '/l1_b_1_1.jpg'
      ]

      var textureCube = new THREE.CubeTextureLoader().load(urls)
      textureCube.format = THREE.RGBFormat
      textureCube.mapping = THREE.CubeRefractionMapping
      this.panoGroup.children[0].material.uniforms.texture.value = textureCube
    },
    changePanoMat(num) {
      // this.hasSand = false
      this.$parent.changePanoEditInfos('nowPanoActiveIndex', num)
      var id = this.resData[this.nowFloor].panos[num].physicalFile.id
      // if(this.resData[this.nowFloor].sandTable_Point.sandTable != null){
      //   this.hasSand = true
      // }
      if(this.resData[this.nowFloor].sandTable_Point.sandPoints != null) {
        var pointNum = this.resData[this.nowFloor].sandTable_Point.sandPoints.findIndex(item => item.panoID === id)
        this.$parent.changePanoEditInfos('sandPointActiveIndex', pointNum)
      }
      this.lon = 270
      this.lat = 0
      this.posObj(this.targetBox, this.camera, 10000, this.lon, this.lat, 0)
      var r = this.resData[this.nowFloor].panos[this.nowPanoActiveIndex].physicalFile.filePath
      var urls = [
        r + '/creat/l1_r_1_1.jpg',
        r + '/creat/l1_l_1_1.jpg',
        r + '/creat/l1_u_1_1.jpg',
        r + '/creat/l1_d_1_1.jpg',
        r + '/creat/l1_f_1_1.jpg',
        r + '/creat/l1_b_1_1.jpg'
      ]
      var textureCube = new THREE.CubeTextureLoader().load(urls)
      textureCube.format = THREE.RGBFormat
      textureCube.mapping = THREE.CubeRefractionMapping
      this.panoGroup.children[0].material.uniforms.texture.value = textureCube
    },
    changePanoMatByFloor(num, num2) {
      this.hasSand = false
      this.$parent.changePanoEditInfos('nowPanoActiveIndex', num)
      console.log(this.resData[num2])
      if(this.resData[num2].panos.length > 0) {
        this.panoGroup.visible = true
        var id = this.resData[num2].panos[num].physicalFile.id
        if(this.resData[num2].sandTable_Point.sandTable != null) {
          this.hasSand = true
        }
        if(this.resData[num2].sandTable_Point.sandPoints != null) {
          var pointNum = this.resData[num2].sandTable_Point.sandPoints.findIndex(item => item.panoID === id)
          this.$parent.changePanoEditInfos('sandPointActiveIndex', pointNum)
        }
        this.lon = 270
        this.lat = 0
        this.posObj(this.targetBox, this.camera, 10000, this.lon, this.lat, 0)
        var r = this.resData[num2].panos[this.nowPanoActiveIndex].physicalFile.filePath
        var urls = [
          r + '/creat/l1_r_1_1.jpg',
          r + '/creat/l1_l_1_1.jpg',
          r + '/creat/l1_u_1_1.jpg',
          r + '/creat/l1_d_1_1.jpg',
          r + '/creat/l1_f_1_1.jpg',
          r + '/creat/l1_b_1_1.jpg'
        ]
        var textureCube = new THREE.CubeTextureLoader().load(urls)
        textureCube.format = THREE.RGBFormat
        textureCube.mapping = THREE.CubeRefractionMapping
        this.panoGroup.children[0].material.uniforms.texture.value = textureCube
      }else{
        this.panoGroup.visible = false
      }
    },
    posObj(obj, cam, r, lon, lat, h) {
      lat = Math.max(-85, Math.min(85, lat))
      var phi = THREE.Math.degToRad(90 - lat)
      var theta = THREE.Math.degToRad(lon)
      obj.position.x = r * Math.sin(phi) * Math.cos(theta) + cam.position.x
      obj.position.y = r * Math.cos(phi) + cam.position.y
      obj.position.z = r * Math.sin(phi) * Math.sin(theta) + cam.position.z
    },
    generatePano(panoGroup, data) {
      var r = data.physicalFile.filePath
      console.log(r)
      var urls = [
        r + '/creat/l1_r_1_1.jpg',
        r + '/creat/l1_l_1_1.jpg',
        r + '/creat/l1_u_1_1.jpg',
        r + '/creat/l1_d_1_1.jpg',
        r + '/creat/l1_f_1_1.jpg',
        r + '/creat/l1_b_1_1.jpg'
      ]
      // var urls = [
      //   r + '/1_r.jpg',
      //   r + '/1_l.jpg',
      //   r + '/1_u.jpg',
      //   r + '/1_d.jpg',
      //   r + '/1_f.jpg',
      //   r + '/1_b.jpg'
      // ]

      var textureCube = new THREE.CubeTextureLoader().load(urls)
      textureCube.format = THREE.RGBFormat
      textureCube.mapping = THREE.CubeRefractionMapping
      var planeUniforms = {
        cPosition: { value: new THREE.Vector3(0, 0, 0) },
        texture: { value: textureCube },
        ...THREE.UniformsLib.lights
      }
      var cubeMat = new THREE.ShaderMaterial({
        uniforms: planeUniforms,
        vertexShader: vertexShader,
        fragmentShader: fragmentShader,
        lights: true
      })
      cubeMat.needsUpdate = true

      // var geometry = new THREE.BoxBufferGeometry(5000, 5000, 5000)
      var geometry = new THREE.SphereBufferGeometry(5000, 32, 32)
      geometry.scale(1, 1, -1)
      var cubeMesh = new THREE.Mesh(geometry, cubeMat)
      cubeMesh.visible = true
      cubeMesh.name = data.fileName
      panoGroup.add(cubeMesh)
    },
    onresize () {
      this.containerW = this.$refs.webgl.getBoundingClientRect().width
      this.containerH = this.$refs.webgl.getBoundingClientRect().height
      this.camera.aspect = this.containerW / this.containerH
      this.camera.updateProjectionMatrix()
      this.renderer.setSize(this.containerW, this.containerH)
    },
    render() {
      this.renderer.render(this.scene, this.camera)
    },
    animate () {
      var delta = this.clock.getDelta()
      this.camera.lookAt(this.targetBox.position)
      this.rafId = requestAnimationFrame(this.animate)
      this.render()
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.onresize, false)
    cancelAnimationFrame(this.rafId)
    this.renderer.dispose()
    this.renderer.forceContextLoss()
    this.renderer.domElement = null
    this.renderer = null
    this.scene = null
    this.camera = null
    this.rafId = null
    this.container = null
    this.mesh = null
    this.controls = null
    this.modelInfo = null
  }
}
</script>
